export const GENDER_OPTIONS = [
  { label: 'gender.male', value: 'Male' },
  { label: 'gender.female', value: 'Female' },
  { label: 'gender.other', value: 'Other' },
]

export const FORM_CONSTANTS = {
  DATE_LIMITS: {
    MIN: '1940-01-01',
    MAX: '2015-01-01',
  },
  PLACEHOLDERS: {
    BIRTH_DATE: 'DD-MM-YYYY',
    DISCORD: 'Nickname#0123',
    ABOUT: 'Like to play',
    FACEBOOK: 'http://facebook.com',
    GENDER: 'Other',
  },
  DEFAULT_LANGUAGE: 'en',
  LANGUAGE_KEY: 'language',
}

export const MEDIA_CONSTANTS = {
  USER_AVATAR: 'userAvatar',
  FORM_DATA_KEYS: {
    MEDIA: 'media',
    MEDIA_TYPE: 'mediaType',
    MEDIA_OWNER_ID: 'mediaOwnerId',
  },
}

export const SOCIAL_MEDIA = {
  FACEBOOK: {
    DEFAULT_URL: 'https://www.facebook.com',
    SITE_NAME: 'facebook',
  },
}

export const INITIAL_FORM_ERRORS = {
  firstName: '',
  nickname: '',
  birthDate: '',
  username: '',
  citizenship: '',
  country: '',
  url: '',
  discord: '',
  facebookLink: '',
}

// Form Field Configuration
export const FORM_FIELD_TYPES = {
  INPUT: 'input',
  SELECT: 'select',
  DATE: 'date',
  TEXTAREA: 'textarea',
}

export const FORM_SECTIONS = {
  PERSONAL_INFO: 'personalInfo',
  CONTACT_INFO: 'contactInfo',
  ADDITIONAL_INFO: 'additionalInfo',
}

// Comprehensive form configuration
export const FORM_CONFIG = {
  [FORM_SECTIONS.PERSONAL_INFO]: {
    title: 'settings.personalInformation',
    fields: [
      {
        id: 'nickname',
        type: FORM_FIELD_TYPES.INPUT,
        label: 'global.forms.labels.nickname',
        name: 'nickname',
        required: true,
        icon: 'pencil',
        placeholder: 'global.forms.labels.nickname',
        validation: 'nickname',
        titlePadding: '9px 60px 7px 38px',
      },
      {
        id: 'firstName',
        type: FORM_FIELD_TYPES.INPUT,
        label: 'global.forms.labels.firstName',
        name: 'firstName',
        required: true,
        icon: 'pencil',
        placeholder: 'global.forms.labels.firstName',
        validation: 'firstName',
        titlePadding: '9px 38px 7px',
        borderBottom: true,
      },
      {
        id: 'lastName',
        type: FORM_FIELD_TYPES.INPUT,
        label: 'global.forms.labels.lastName',
        name: 'lastName',
        required: true,
        icon: 'pencil',
        placeholder: 'global.forms.labels.lastName',
        validation: 'lastName',
        titlePadding: '9px 38px 7px',
      },
      {
        id: 'birthDate',
        type: FORM_FIELD_TYPES.DATE,
        label: 'id.birthdate',
        name: 'birthDate',
        required: true,
        icon: 'pencil',
        placeholder: FORM_CONSTANTS.PLACEHOLDERS.BIRTH_DATE,
        validation: 'birthDate',
        titlePadding: '9px 38px 7px',
        min: FORM_CONSTANTS.DATE_LIMITS.MIN,
        max: FORM_CONSTANTS.DATE_LIMITS.MAX,
      },
      {
        id: 'gender',
        type: FORM_FIELD_TYPES.SELECT,
        label: 'global.forms.labels.gender',
        name: 'gender',
        required: false,
        icon: 'pencil',
        placeholder: FORM_CONSTANTS.PLACEHOLDERS.GENDER,
        validation: 'gender',
        titlePadding: '9px 38px 7px',
        options: 'genderOptions',
        clearable: true,
      },
      {
        id: 'citizenship',
        type: FORM_FIELD_TYPES.SELECT,
        label: 'global.forms.labels.citizenship',
        name: 'citizenship',
        required: true,
        validation: 'citizenship',
        titlePadding: '9px 60px 7px 38px',
        options: 'countriesList',
        clearable: true,
      },
    ],
  },
  [FORM_SECTIONS.CONTACT_INFO]: {
    title: 'settings.contactInformation',
    fields: [
      {
        id: 'country',
        type: FORM_FIELD_TYPES.SELECT,
        label: 'settings.selectCountry',
        name: 'country',
        required: true,
        validation: 'country',
        titlePadding: '9px 60px 7px 38px',
        options: 'countriesList',
        clearable: true,
      },
      {
        id: 'facebookLink',
        type: FORM_FIELD_TYPES.INPUT,
        label: 'teams.form.facebook',
        name: 'facebookLink',
        required: false,
        icon: 'pencil',
        placeholder: FORM_CONSTANTS.PLACEHOLDERS.FACEBOOK,
        titlePadding: '9px 38px 7px',
        validation: 'facebookLink',
      },
      {
        id: 'discord',
        type: FORM_FIELD_TYPES.INPUT,
        label: 'teams.form.discord',
        name: 'discord',
        required: true,
        icon: 'pencil',
        placeholder: FORM_CONSTANTS.PLACEHOLDERS.DISCORD,
        validation: 'discord',
        titlePadding: '9px 38px 7px',
        borderBottom: true,
      },
      {
        id: 'url',
        type: FORM_FIELD_TYPES.INPUT,
        label: 'settings.passportAddress',
        name: 'url',
        required: true,
        icon: 'pencil',
        placeholder: 'userData?.url',
        validation: 'url',
        titlePadding: '9px 38px 7px',
        borderBottom: true,
      },
      {
        id: 'email',
        type: FORM_FIELD_TYPES.INPUT,
        label: 'global.forms.placeholders.email',
        name: 'email',
        required: false,
        icon: 'email',
        placeholder: 'userData?.email',
        titlePadding: '9px 38px 7px',
        disabled: true,
        borderBottom: true,
      },
      {
        id: 'language',
        type: FORM_FIELD_TYPES.SELECT,
        label: 'global.forms.labels.language',
        name: 'language',
        required: false,
        titlePadding: '9px 38px 7px',
        options: 'INTERFACE_LANGUAGES_OPTIONS',
        onChange: 'onLanguageChange',
      },
    ],
  },
  [FORM_SECTIONS.ADDITIONAL_INFO]: {
    title: 'settings.about',
    fields: [
      {
        id: 'about',
        type: FORM_FIELD_TYPES.TEXTAREA,
        name: 'about',
        required: false,
        icon: 'pencil',
        placeholder: FORM_CONSTANTS.PLACEHOLDERS.ABOUT,
        titlePadding: '16px 38px 19px',
        margin: '0px 50px',
        borderBottom: true,
      },
    ],
  },
}

// Special sections that need custom rendering
export const SPECIAL_SECTIONS = {
  EMAIL_ACTIVATION: {
    condition: '!userData.emailActivated',
    title: 'settings.acitvate.account',
    titlePadding: '9px 38px 7px',
    component: 'Button',
    componentProps: {
      label: 'global.forms.labels.send.email',
      type: 'button',
      color: 'white',
      active: true,
      size: 'sm',
      variant: 'changePassword',
      action: 'activateAccount',
    },
  },
  PASSWORD_CHANGE: {
    component: 'Button',
    componentProps: {
      label: 'password.reset.change',
      type: 'button',
      color: 'white',
      active: true,
      size: 'sm',
      variant: 'changePassword',
      action: 'changePassword',
    },
  },
}
